import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes';
import {
  initCurrentUserStateMiddleware,
  checkAccessMiddleware,
  setPageTitleMiddleware,
  checkAuthorization,
  checkUserManagementAccess
} from './middlewares';

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: 'is-active',
  mode: 'history',
  routes
});

router.beforeEach(initCurrentUserStateMiddleware);
router.beforeEach(checkAccessMiddleware);
router.beforeEach(setPageTitleMiddleware);
router.beforeEach(checkAuthorization);
router.beforeEach(checkUserManagementAccess);

export default router;